// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-fields {
  display: grid;
  width: min(100%, 52rem);
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-fields + .test-detail-fields {
  margin-top: 0.65rem;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.3rem;
  min-width: 0;
}

.test-detail-label {
  margin: 0;
  white-space: nowrap;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

.test-detail-field .form-control {
  height: 1.85rem;
  font-size: 0.78rem;
  width: 100%;
  max-width: none;
  text-align: left;
}

.ppt-calculations input[readonly] {
  background-color: #e9ecef;
  color: #6c757d;
  font-weight: 600;
}

@media (max-width: 768px) {
  .test-detail-fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 575.98px) {
  .test-detail-fields {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-ppt-detail.component.scss"],"names":[],"mappings":"AAAA;EAAuB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAKxF;;AAJA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,kBAAA;EAAoB,yBAAA;EAA2B,sBAAA;AAc/I;;AAbA;EAAsB,aAAA;EAAe,uBAAA;EAAyB,gDAAA;EAAkD,iBAAA;AAoBhH;;AAnBA;EAA4C,mBAAA;AAuB5C;;AAtBA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,oBAAA;EAAsB,WAAA;EAAa,YAAA;AA8B/F;;AA7BA;EAAqB,SAAA;EAAW,mBAAA;EAAqB,kBAAA;EAAoB,WAAA;EAAa,gBAAA;AAqCtF;;AApCA;EACC,eAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAuCD;;AArCA;EAAoC,yBAAA;EAA2B,cAAA;EAAgB,gBAAA;AA2C/E;;AAzCA;EACC;IAAsB,gDAAA;EA6CrB;AACF;AA3CA;EACC;IAAsB,0BAAA;EA8CrB;AACF","sourcesContent":[".test-detail-section { border: 1px solid #e3e8ef; border-radius: 4px; padding: 0.65rem; background: #ffffff; }\n.test-detail-title { margin: 0 0 0.55rem; font-size: 0.85rem; font-weight: 700; color: #3f4954; text-align: center; text-transform: uppercase; letter-spacing: 0.02em; }\n.test-detail-fields { display: grid; width: min(100%, 52rem); grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 0.65rem 1rem; }\n.test-detail-fields + .test-detail-fields { margin-top: 0.65rem; }\n.test-detail-field { display: flex; flex-direction: column; align-items: stretch; gap: 0.3rem; min-width: 0; }\n.test-detail-label { margin: 0; white-space: nowrap; font-size: 0.85rem; color: #555; font-weight: 600; }\n.test-detail-field .form-control {\n\theight: 1.85rem;\n\tfont-size: 0.78rem;\n\twidth: 100%;\n\tmax-width: none;\n\ttext-align: left;\n}\n.ppt-calculations input[readonly] { background-color: #e9ecef; color: #6c757d; font-weight: 600; }\n\n@media (max-width: 768px) {\n\t.test-detail-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (max-width: 575.98px) {\n\t.test-detail-fields { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
